import React, { useState } from "react";
import { Modal, Box, TextField, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import { COLORS } from "../constants/constants";

// Định nghĩa interface cho props
interface BookingModalProps {
  open: boolean;
  handleClose: () => void;
  serviceName: string;
}

const BookingModal: React.FC<BookingModalProps> = ({
  open,
  handleClose,
  serviceName,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    service_name: serviceName,
  });
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  const validatePhone = (value: string) => {
    const vnPhoneRegex =
      /^(0|\+84)(3[2-9]|5[6|8|9]|7[06-9]|8[1-9]|9[0-9])[0-9]{7}$/;
    return vnPhoneRegex.test(value);
  };

  React.useEffect(() => {
    setFormData((prev) => ({ ...prev, service_name: serviceName }));
  }, [serviceName]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setError("");
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setPhone(formData.phone);
    if (!validatePhone(phone)) {
      setError("Số điện thoại không hợp lệ (VD: 0912345678)");
    } else {
      setError("");
      try {
        await addDoc(collection(db, "orders"), {
          ...formData,
          timestamp: new Date(),
        });

        setFormData({ name: "", phone: "", service_name: "" });
        handleClose();
        alert(
          `Cảm ơn ${formData.name} đã liên hệ với chúng tôi. Chúng tôi sẽ phản hồi sớm nhất có thể!`
        );
      } catch (e) {
        console.error("Error adding document: ", e);
      }
    }
  };

  const modalStyle = {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="booking-modal-title"
    >
      <Box sx={modalStyle} className="bg-white">
        <div className="flex justify-between items-center mb-4">
          <Typography
            id="booking-modal-title"
            variant="h6"
            component="h2"
            className="text-gray-800"
          >
            Thông tin của bạn
          </Typography>
          <Button onClick={handleClose} className="!text-primary_blue">
            <CloseIcon />
          </Button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <TextField
            fullWidth
            label="Tên bạn"
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
            className="w-full"
          />

          <TextField
            fullWidth
            label="Số điện thoại"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            required
            error={!!error}
            helperText={error}
            variant="outlined"
            className="w-full"
          />

          <TextField
            fullWidth
            label="Yêu cầu của bạn"
            name="service_name"
            value={formData.service_name}
            onChange={handleChange}
            multiline
            rows={4}
            variant="outlined"
            className="w-full"
          />

          <Button
            type="submit"
            variant="contained"
            className="!text-base !bg-primary_blue !text-white !px-4 !py-2"
            sx={{
              textTransform: "none",
              width: "100%",
              backgroundColor: COLORS.primary_blue,
              "&:hover": {
                backgroundColor: COLORS.primary_blue,
              },
            }}
          >
            Gửi
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default BookingModal;
